import gql from 'graphql-tag';

export const deleteCoverageHours = gql`
  mutation deleteCoverageHours($input: InputDeleteCoverageHours!) {
    deleteCoverageHours(input: $input)
  }
`;
